// extracted by mini-css-extract-plugin
export var accordion = "_bc-0";
export var chevron = "_bc-3";
export var closed = "_bc-2";
export var content = "_bc-4";
export var open = "_bc-1";
export var rotate = "_bc-5";